import React from 'react';
import {t} from '@lingui/core/macro';

import FiltersModal from 'shared/ui/Modal/FiltersModal/FiltersModal';
import {FILTERS_KEPT_NONE} from 'shared/lib/filterHelper';

export interface IMonitorFiltersFormHandlerProps {
    onSuccess: () => void,
    handleClose: () => void,
}

interface IMonitorFiltersModalProps {
    open: boolean,
    handleClose: () => void,
    FormHandler: React.ComponentType<IMonitorFiltersFormHandlerProps>,
}

const MonitorFiltersModal: React.FC<IMonitorFiltersModalProps> = ({open, handleClose, FormHandler}) => (
    <FiltersModal header={t`Фильтры`} open={open} handleClose={handleClose} keepParams={FILTERS_KEPT_NONE}>
        <FormHandler
            onSuccess={handleClose}
            handleClose={handleClose}
        />
    </FiltersModal>
);

export default MonitorFiltersModal;
